import React from 'react';
import classnames from 'classnames';
import { DividerProps } from './types';
import styles from './index.module.scss';

function Divider({
  classNames,
  'data-test-id': dataTestId,
  type = 'solid',
  children = null,
}: DividerProps) {
  const dividerClasses = classnames(styles.divider, classNames);
  const lineClass = classnames(styles[`divider__${type}`]);

  if (!children) {
    return (
      <div className={dividerClasses} data-test-id={dataTestId}>
        <div className={lineClass} />
      </div>
    );
  }

  return (
    <div className={dividerClasses} data-test-id={dataTestId}>
      <div className={lineClass} />
      <div
        data-test-id={`${dataTestId}-children`}
        className={styles.divider__content}
      >
        {children}
      </div>
      <div className={lineClass} />
    </div>
  );
}

export default Divider;
